import common_en from './common_en.json'
import common_fr from './common_fr.json'
import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'

const lcr_ca_resources = {
  en: {
    ...forms_en,
    ...common_en,
    ...contactInfo_en,
  },
  fr: {
    ...forms_fr,
    ...common_fr,
    ...contactInfo_fr,
  },
}

export default lcr_ca_resources
